import { useEffect, useState } from "react";
import ApiService from "../../services/api.service";
import { coachAffiliationErrorCopy } from "../../utils/inviteErrorCopy";
import "../../pages/client/ClientLayout.css";
import "../../pages/coach/CoachPages.css";

// "Metro Youth invited your team to join" — accept or decline a league's
// #hashtag invitation.
//
// WHY A BANNER AND NOT A TAB. There is no deep link into the web console: the
// SMS says "open the app" and the push is iOS-only, so a coach who signs in
// here has to STUMBLE on the invitation. A strip above every coach page can't
// be missed; a /coach/leagues tab they'd never click would be worse. One GET
// per layout mount.
//
// Renders nothing on ANY error, including the 404 noTeam a coach with zero
// teams gets from the route guard (which sits above the affiliations
// dispatch). A broken banner must never push the roster down the page.
//
// Answering is per-LEAGUE, not per-team: PUT/DELETE
// /coach/affiliations/{leagueId} flips every pending row for that league at
// once, so two teams invited by one league are one banner and one decision.
export default function CoachLeagueInviteBanner() {
  const [pending, setPending] = useState([]);
  const [busy, setBusy] = useState(null); // leagueId currently being answered
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      const resp = await ApiService.getCoachAffiliations();
      setPending((resp?.affiliations || []).filter((a) => a.status === "pending"));
    } catch {
      setPending([]);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const groups = Object.values(
    pending.reduce((acc, a) => {
      acc[a.leagueId] = acc[a.leagueId] || {
        leagueId: a.leagueId,
        leagueName: a.leagueName || "A league",
        teamNames: [],
      };
      acc[a.leagueId].teamNames.push(a.teamName || "your team");
      return acc;
    }, {})
  );

  const answer = async (leagueId, accept) => {
    if (!accept && !window.confirm("Decline this invitation? They can invite you again later if you change your mind.")) return;
    setBusy(leagueId);
    setError(null);
    try {
      if (accept) {
        await ApiService.acceptCoachAffiliation(leagueId);
      } else {
        await ApiService.declineCoachAffiliation(leagueId);
      }
      // Accepting changes leagueName on GET /coach/teams and adds the league's
      // games to the schedule — data owned by three sibling pages with no
      // shared coach context between them. A reload is the honest way to get
      // all of them consistent; a targeted refetch would leave two of the
      // three stale.
      window.location.reload();
    } catch (err) {
      setError(coachAffiliationErrorCopy(err));
      setBusy(null);
      load();
    }
  };

  if (groups.length === 0) return null;

  return (
    <>
      {groups.map((g) => (
        <div key={g.leagueId} className="coach-league-invite-banner">
          <div>
            <div className="coach-history-matchup">
              {g.leagueName} invited {g.teamNames.length > 1 ? "your teams" : g.teamNames[0]} to join
            </div>
            <div className="coach-history-date">
              Their games will show up in your schedule. You keep your roster.
            </div>
          </div>
          <div className="coach-league-invite-actions">
            <button className="client-button" disabled={busy === g.leagueId}
              onClick={() => answer(g.leagueId, true)}>
              {busy === g.leagueId ? "…" : "Accept"}
            </button>
            <button className="client-button-secondary" disabled={busy === g.leagueId}
              onClick={() => answer(g.leagueId, false)}>
              Decline
            </button>
          </div>
        </div>
      ))}
      {error && <div className="client-error">{error}</div>}
    </>
  );
}
